import { render, staticRenderFns } from "./BeansAndGrinded.vue?vue&type=template&id=08ea9976&scoped=true&"
import script from "./BeansAndGrinded.vue?vue&type=script&lang=js&"
export * from "./BeansAndGrinded.vue?vue&type=script&lang=js&"
import style0 from "./BeansAndGrinded.vue?vue&type=style&index=0&id=08ea9976&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ea9976",
  null
  
)

export default component.exports